import { NavigationPath } from "..";

const leasingAccess = [
  NavigationPath.OFFER_REQUESTS_ROUTE,
  NavigationPath.ADD_OFFER_REQUEST_ROUTE,
  NavigationPath.OFFER_RESPONSES_ROUTE,
  NavigationPath.SINGLE_OFFER_RESPONSES_ROUTE,
  NavigationPath.SINGLE_RESPONSE_ROUTE,
];

export const roleAccess: { [role: string]: string[] } = {
  "S-Premium Admin": [
    NavigationPath.OFFER_REQUESTS_ROUTE,
    NavigationPath.ADD_OFFER_REQUEST_ROUTE,
    NavigationPath.EDIT_OFFER_REQUEST_ROUTE,
    NavigationPath.OFFER_RESPONSES_ROUTE,
    NavigationPath.SINGLE_OFFER_RESPONSES_ROUTE,
    NavigationPath.SINGLE_RESPONSE_ROUTE,
    NavigationPath.USERS_ROUTE,
    NavigationPath.ADD_USER_ROUTE,
    NavigationPath.EDIT_USER_ROUTE,
    NavigationPath.INSURANCE_ROUTE,
    NavigationPath.ADD_INSURANCE_ROUTE,
    NavigationPath.EDIT_INSURANCE_ROUTE,
  ],
  "S-Leasing Admin": leasingAccess,
  Banka: leasingAccess,
  "Osiguravajuće društvo": [
    NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE,
    NavigationPath.INSURANCE_OFFER_RESPONSE_ROUTE,
    NavigationPath.ORDERS_ROUTE,
  ],
};
